const consent = require('./consent');
const track = require('./track');

const { Branch } = require('./branch');
const { Facebook } = require('./facebook');
const { GoogleAnalytics } = require('./google-analytics');
const { MParticle } = require('./mparticle');

module.exports = {
  ...track,
  consent,
  Branch,
  Facebook,
  GoogleAnalytics,
  MParticle,
};
